import {useCallback, useEffect, useRef, useState} from "react";

type opts = {
  /** секунды, 0 — таймер выключен */
  limitSec: number;
  /** сброс при смене шага */
  stepKey: string;
  /** вызов один раз при достижении 0 */
  onExpire: () => void;
  /** пауза — таймер не тикает, но значение сохраняется */
  paused?: boolean;
};

export function useActionResponseCountdown({limitSec, stepKey, onExpire, paused = false}: opts) {
  const [remaining, setRemaining] = useState<number | null>(null);
  const fired = useRef(false);

  useEffect(() => {
    fired.current = false;
    if (!limitSec || limitSec <= 0) {
      setRemaining(null);
      return;
    }
    setRemaining(limitSec);
  }, [limitSec, stepKey]);

  useEffect(() => {
    if (paused) return;
    if (remaining === null || remaining <= 0) {
      if (remaining === 0 && !fired.current) {
        fired.current = true;
        onExpire();
      }
      return;
    }
    const id = window.setInterval(() => {
      setRemaining((r) => (r === null ? r : r - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [remaining, onExpire, paused]);

  const cancel = useCallback(() => {
    setRemaining(null);
  }, []);

  return {remaining, cancel};
}
